import React from 'react';

export interface StandardPageHeaderProps {
  /** Main page title e.g. 'Minhas Tarefas' */
  title: string;
  /** Lucide icon element rendered left of title */
  icon?: React.ReactNode;
  /** Right-aligned content on the title row (counters, summary badges) */
  titleActions?: React.ReactNode;
}

/**
 * StandardPageHeader — Compact title bar for all management pages.
 *
 * Icon + Title flush below the Ribbon with consistent 16px top padding.
 * Optional titleActions slot for right-aligned pill indicators.
 */
export function StandardPageHeader({ title, icon, titleActions }: StandardPageHeaderProps) {
  return (
    <div className="shrink-0 flex items-center justify-between pt-4 pb-3" style={{ paddingLeft: 'var(--module-page-padding)', paddingRight: 'var(--module-page-padding)' }}>
      <div className="flex items-center gap-2 min-w-0">
        {icon && <span className="shrink-0 text-zinc-500 dark:text-zinc-400">{icon}</span>}
        <h1 className="text-2xl font-bold text-zinc-900 dark:text-zinc-100 truncate">{title}</h1>
      </div>
      {titleActions && (
        <div className="flex items-center gap-2 shrink-0">{titleActions}</div>
      )}
    </div>
  );
}

export default StandardPageHeader;
